import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import {SectionWrapper } from '../../Styles/style'
import styled from '@emotion/styled'

import Accordian from "../../Components/Accordion"
const WhyWrapper = styled.div`
padding: 6rem 0;
`
const SectionHeading = styled.div`
font-size: 50px;
text-align: center;
font-family: "Poppins-Bold";
`
const Protocol = () => {
  return (
    <div>
       <SectionWrapper id="faq">
        <Container maxWidth="xl">
          
        <SectionHeading>FAQ
            </SectionHeading>
            <WhyWrapper>

         <Accordian />
            </WhyWrapper>
        </Container>
        </SectionWrapper>
    </div>
  )
}

export default Protocol